<template>
<div :key="keyAssigned" class="widthFull">
  <div :key="keyAssigned"  class="container">
    <div  :key="keyAssigned" class="row">
      <div class="col-md-4 mb-3">
        <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
          <select v-model="province" :key="keyAssigned" autocomplete="randomy" id="province" name="province" class="form-control" data-vv-as="Provincia" v-validate="{required:true}" :class="{ 'is-invalid': errors.has('form-1.province'), valid: !!province }">
            <option disabled value="" selected="selected"></option>
            <option v-for="province in provincies" :key="province.sigla" v-bind:value="province.sigla">
              {{province.sigla}} - {{province.provincia}}
            </option>
          </select>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="niceInputLabel" for="province">Provincia</label>
          <div v-if="provinciesState">
            <font-awesome-icon class="loadSpinner" id="loadProvince" icon="spinner" size="1x" pulse />
          </div>
          <div v-if="errors.has('form-1.province')" class="invalid-feedback">
            {{ errors.first("form-1.province") }}
          </div>
        </div>
      </div>
      <!-- CITY INPUT ROW 2 -->
      <div class="col-md-4 mb-3">
        <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
          <span v-if="cityError" class="formError">Prima scegli Provincia</span>
          <select class="form-control" :key="keyAssigned" autocomplete="randomu" v-model="city" v-on:click="checkProvince" id="city" name="city" data-vv-as="Località" v-validate="{required:true}" :disabled="citiesState"
            :class="{ 'is-invalid': errors.has('form-1.city'), valid: !!city }">
            <option disabled value="" selected="selected"></option>

            <option v-for="city in cities" :key="city.comune" v-bind:value="{cityistat: city.istat, city: city.comune}">
              {{city.comune}}
            </option>

          </select>

          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="niceInputLabel" for="city">Località</label>

          <div v-if="citiesState">
            <font-awesome-icon class="loadSpinner" id="loadCity" icon="spinner" size="1x" pulse />
          </div>
          <div v-if="errors.has('form-1.city')" class="invalid-feedback">
            {{ errors.first("form-1.city") }}
          </div>
        </div>
      </div>
      <!-- ZIP INPUT ROW 2 -->
      <div class="col-md-4 mb-3">
        <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
          <span v-if="zipError" class="formError">Prima scegli città</span>
          <select class="form-control" :key="keyAssigned" autocomplete="randomi" v-model="zip" v-on:click="checkZip" id="zip" name="zip" data-vv-as="CAP" v-validate="{required:true}" :disabled="zipsState"
            :class="{ 'is-invalid': errors.has('form-1.zip'), valid: !!zip }">
            <option value="" disabled :selected="true"></option>
            <option v-for="zip in zips" :key="zip.cap" v-bind:value="zip.cap">
              {{zip.cap}}
            </option>
          </select>
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="niceInputLabel" for="zip">CAP</label>
          <div v-if="zipsState">
            <font-awesome-icon class="loadSpinner" id="loadZips" icon="spinner" size="1x" pulse />
          </div>
          <div v-if="errors.has('form-1.zip')" class="invalid-feedback">
            {{ errors.first("form-1.zip") }}
          </div>
        </div>
      </div>

      <!-- ADDRESS INPUT ROW 3 -->
      <div class="col-md-6 mb-3">
        <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
          <input type="text" autocomplete="randomq" :key="keyAssigned" class="form-control" v-model="adress" id="adress" name="adress" data-vv-as="Indirizzo" v-validate="{required:true, max: 128, min: 5}"
            :class="{ 'is-invalid': errors.has('form-1.adress'), valid: !!adress }">
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="niceInputLabel" for="adress">Indirizzo (via, piazza, etc.)</label>
          <div v-if="errors.has('form-1.adress')" class="invalid-feedback">
            {{ errors.first("form-1.adress") }}
          </div>
        </div>
      </div>
      <!-- CIVIC INPUT ROW 3 -->
      <div class="col-md-6 mb-3">
        <div class="group custInput" :class="{'inputHSD': brand == 'HAPPYBONUS' }">
          <input type="text" autocomplete="randomq" :key="keyAssigned" class="form-control" v-model="civic" id="civic" name="civic" data-vv-as="N. Civico" v-validate="{required:true, max: 15, min: 1}"
            :class="{ 'is-invalid': errors.has('form-1.civic'), valid: !!civic }">
          <span class="highlight"></span>
          <span class="bar"></span>
          <label class="niceInputLabel" for="civic">N. Civico</label>
          <div v-if="errors.has('form-1.civic')" class="invalid-feedback">
            {{ errors.first("form-1.civic") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import Vue from 'vue'

const moment = require('moment')

export default {
  name: 'address',
  props: {
    parseAdress: String,
    parseCivic: String,
    parseProvince: String,
    parseCity: String,
    parseZip: String,
    keyAssigned: String
  },
  data() {
    return {
      adress: '',
      civic: '',
      provincies: [],
      province: '',
      provinciesState: true,
      cities: [],
      citiesState: false,
      zips: [],
      zipsState: false,
      cityError: false,
      zipError: false,
      city: '',
      zip: '',
      brand: process.env.BRAND,
      loadedOnce: false
    }

  },
  methods: {
    populateProvincies: async function() {
      const {
        provincies,
        provinciesState
      } = this
      await axios({
          url: process.env.ROOT_API + 'api/getProvinciesAll',
          method: 'POST',
          headers: {
            'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
            'Content-type': 'application/json'
          }
        })
        .then(resp => {
          this.provincies = resp.data.provincies;
          this.provinciesState = false

        })
        .catch(resp => {
          this.provincies = [];
          this.provinciesState = false
        })
    },
    checkProvince: function() {

      const {
        province
      } = this
      if (province) {
        this.cityError = false
      } else {
        this.cityError = true
      }

    },
    checkZip: function() {
      const {
        city
      } = this
      if (city) {
        this.zipError = false
      } else {
        this.zipError = true
      }
    },

    setCap: async function(cap) {
      for (var x in this.zips) {
        if (this.zips[x].cap == cap.toUpperCase()) {
          this.zip = this.zips[x].cap
        }
      }
    },
    setCity: async function(city) {
      for (var x in this.cities) {
        if (this.cities[x].comune == city.toUpperCase()) {
          var k = {
            cityistat: this.cities[x].istat,
            city: city.toUpperCase(),
          }
          this.city = k
        }
      }
    },
    setProvince: async function(province) {
      for (var x in this.provincies) {
        if (this.provincies[x].sigla == province.toUpperCase()) {
          this.province = this.provincies[x].sigla
        }
      }
    },

    preloadAddress: async function(){

      var _vue = this

      if( this.parseAdress ){
        this.adress = this.parseAdress
      }
      if( this.parseCivic ){
        this.civic = this.parseCivic
      }

      if( this.parseProvince ){
        var province = _vue.parseProvince
        var x = await _vue.setProvince(province)
      }

    }
  },
  watch: {
    async getProfile() {

    },
    adress: function(val) {
      if (val) {
        this.adress = this.adress.toUpperCase()
        this.$emit('setAddress', val.toUpperCase())
      }
    },

    zip(val) {
      this.$emit('setZip', val)
    },

    civic: function(val) {
      if (val) {
        this.civic = this.civic.toUpperCase()
        this.$emit('setCivic', val.toUpperCase())
      }
    },

    province: function(newProvince) {
      var _vue = this
      this.zips = [];
      this.cities = [];
      this.zip = '';
      this.city = ''
      this.cityError = false
      this.zipError = false
      this.$emit('setProvince', newProvince)
      if (newProvince) {
        this.citiesState = true
        axios({
            url: process.env.ROOT_API + 'api/getComuni',
            method: 'POST',
            data: {
              provincia: newProvince
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {

            _vue.cities = resp.data.cities
            if( _vue.parseCity && !_vue.loadedOnce){
              _vue.setCity(_vue.parseCity)
            }
            _vue.citiesState = false
          })
          .catch(resp => {
            this.cities = [];
            this.citiesState = false
          })
      }
    },

    city: function(newCity) {
      var _vue = this
      this.zipError = false
      this.zips = [];
      this.zip = '';
      this.$emit('setCity', newCity)
      if (newCity.cityistat) {
        this.zipsState = true
        axios({
            url: process.env.ROOT_API + 'api/getCap',
            method: 'POST',
            data: {
              istat: newCity.cityistat
            },
            headers: {
              'Authorization': 'Bearer ' + process.env.AUTH_TOKEN,
              'Content-type': 'application/json'
            }
          })
          .then(resp => {
            this.zips = resp.data.zips
            if( _vue.parseZip && !_vue.loadedOnce){
              _vue.setCap(_vue.parseZip)
              _vue.loadedOnce = true
            }
            this.zipsState = false
          })
          .catch(resp => {
            this.zips = [];
            this.zipsState = false
          })
      }
    },

  },
  async mounted() {
    await this.populateProvincies()
    await this.preloadAddress()
  }

}
</script>

<style lang="css" scoped>
.maxSem{
  max-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/calcolatore/address.vue